import React, { ReactNode } from "react";

interface Props {
  children?: ReactNode;
  backgroundColor?: string;
  onClose?: () => void;
}

export default function NotificationContainer({ children, backgroundColor, onClose }: Props) {
  if (!children) {
    return null;
  }

  return (
    <div
      className="w-fit border rounded p-5 transition relative mx-auto"
      style={{ backgroundColor: backgroundColor || "#fff" }}
    >
      {children}
      {onClose && (
        <button
          onClick={onClose}
          className="text-sm absolute right-1 top-0 bg-transparent hover:bg-transparent p-0 w-fit"
        >
          ×
        </button>
      )}
    </div>
  );
}
